//
// 开关
// ============================================================
import Ns from "./utility";

const Tree = () => new Ns({
    el: ".tree-wrapper",
    eventHandle: [{
        type: "click",
        entrust: ".item-a",
        callback:  function (ev) {

            if (ns(this).next().get().length != 0){
                ev.preventDefault();
            }

            let aHeight = ns(this).getStyle("height");

            Ns.each(ns(this).parents(".tree-wrapper").children().get(0).children, item => {
               if (ns(this).parents(item).get(0) != item) {
                   ns(item).removeClass("active").find(".tree-list").css("height", "0").removeAttr("style");
                   ns(item).find(".item.active").removeClass("active");
               }

            });

            ns(this).parents(".tree-list").prev().removeClass("color");
            ns(this).parents(".tree-list").find("a.color").removeClass("color");
            ns(this).addClass("color");

            ns(this).parent().addClass("active");

            if (ns(this).next().get().length != 0) {
                let liLength = ns(this).next().get(0).children.length;
                ns(this).next().css("height", aHeight*liLength + "px");

                setTimeout( () => {
                    ns(this).next().removeAttr("style")
                }, 500)
            }

            return true
        }
    }],
});

module.exports = Tree;


// WEBPACK FOOTER //
// src/js/tree.js